import dashboardModule from "../vxPanelGrid.module";

dashboardModule.directive('htmlPanel', function($sce, msgBus, msgBusActions, $rootScope) {
        return {
            restrict: 'E',
            scope: {
                content: '='
            },
            template: '<div class="html-panel-content" ng-bind-html="trustedContent"></div>',
            link: function(scope, element) {
                // Trust the HTML content so it can be rendered correctly
                scope.trustedContent = $sce.trustAsHtml(scope.content.content);
                
                // Handle clicks on elements with data-navigate attribute
                element.on('click', function(event) {
                    var target = angular.element(event.target).closest('[data-navigate]');
                    if (target.length > 0) {
                        var navigateData = target.attr('data-navigate');
                        if (navigateData) {
                            try {
                                var data = JSON.parse(navigateData);
                                console.log('Navigate data:', data);
                                if (data.type === 'jobs' && data.date) {
                                    // Navigate to jobs page with selected date
                                    $rootScope.$apply(function() {
                                        msgBus.emitMsg(msgBusActions.shellOpenTabByType, {
                                            type: 'jobs-filtered',
                                            id: null,
                                            tab: data.date
                                        });
                                    });
                                } else if (data.type === 'jobs-month' && data.startDate && data.endDate) {
                                    // Navigate to jobs page with month date range
                                    $rootScope.$apply(function() {
                                        msgBus.emitMsg(msgBusActions.shellOpenTabByType, {
                                            type: 'jobs-month',
                                            id: null,
                                            tab: { startDate: data.startDate, endDate: data.endDate }
                                        });
                                    });
                                }
                            } catch (e) {
                                console.error('Invalid navigate data:', e);
                            }
                        }
                    }
                });
                
                // Cleanup
                scope.$on('$destroy', function() {
                    element.off('click');
                });
            }
        };
    });
